import React, { useEffect, useState } from 'react';
import { CgSpinnerAlt } from 'react-icons/cg';

import { useCaseLock } from '../../../../common/caseLocking/CaseLockContext';
import { FlexCol, FlexRow } from '../../../../common/components/v2';
import styles from '../../styles.module.scss';

export const FileUpload = ({
  showLeftLabel = true,
  leftItem = '',
  selectedFiles,
  type,
  multiple = true,
  uploadText = 'Upload',
  ongoingUpload = false,
  uploadType = 'application/pdf', // New prop for file type acceptance
  disabled = false,
}: {
  showLeftLabel?: boolean;
  leftItem?: string;
  selectedFiles: (files: any, type: string) => void;
  type: string;
  multiple?: boolean;
  uploadText?: string;
  ongoingUpload?: boolean;
  uploadType?: string;
  disabled?: boolean;
}) => {
  const { isLockedForActions } = useCaseLock();
  const isUploadDisabled = disabled || isLockedForActions;
  const [isUploading, setisUploading] = useState(ongoingUpload);
  const fileUploader = React.createRef<HTMLInputElement>();

  useEffect(() => {
    setisUploading(ongoingUpload);
  }, [ongoingUpload]);

  if (isUploadDisabled) {
    return null;
  }

  const onUploadClick = () => {
    if (fileUploader.current) {
      fileUploader.current.click();
    }
  };

  const onFileSelection = (event: any) => {
    event.preventDefault();
    // onChange event is fired with empty file list also.
    if (event.target.files.length > 0) {
      selectedFiles(event.target.files, type);
      setisUploading(true);
    }

    // Clear input. Otherwise, choosing the same file cannot trigger onChange
    // event.
    event.target.value = '';
  };
  return (
    <>
      <FlexRow className={styles.UploadContainer}>
        {showLeftLabel ? (
          <span className={styles.TaskLeftCell}>{leftItem}</span>
        ) : (
          <></>
        )}
        <div className={styles.UploadLink} onClick={onUploadClick}>
          <input
            ref={fileUploader}
            type="file"
            hidden
            accept={uploadType}
            multiple={multiple}
            onChange={onFileSelection}
          />
          {uploadText}
        </div>
        {isUploading && (
          <FlexCol className={styles.UploadIcon}>
            <CgSpinnerAlt
              style={{
                animation: 'spin 1.2s linear infinite',
              }}
            />
          </FlexCol>
        )}
      </FlexRow>
    </>
  );
};
